module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-white-on-red-dark-3a68d838de765a57127da2bf1a691173.png";